<app-switch
  #switch
  *isAllow="[20, 36]"
  [checked]="!!item().published"
  (changeStatus)="onToggle($event, switch)"
></app-switch>
